import { lazy } from "react";
export { REQUEST_REGISTRY_PATH } from "./request-registry-path";
export const RequestRegistryPage = lazy(() => import("./request-registry"));
